import React, { useMemo } from 'react'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import CruiseLuxPlusInclusionList from './CruiseLuxPlusInclusionList'

import { buildEvergreenPackageInclusions } from 'lib/cruises/cruiseInclusionsUtils'
import styled from 'styled-components'
import { rem } from 'polished'

const PromotionListWrapper = styled.div`
  padding: ${rem(4)} 0;
`

interface Props {
  offer: App.CruiseOffer
  evergreenInclusions?: Array<App.EvergreenInclusion>
  tileInclusions?: Array<App.OfferInclusion>
  standardInclusions: Array<App.PackageInclusion>
  luxPlusInclusions: Array<App.PackageInclusion>
  gap?: React.ComponentProps<typeof Group>['gap']
}

function CruiseInclusionList({ offer, standardInclusions, luxPlusInclusions, evergreenInclusions, tileInclusions, gap = 8 }: Props) {
  const allStandardInclusions = useMemo(() => {
    const evergreenPackageInclusions = buildEvergreenPackageInclusions(evergreenInclusions || [])
    const flashOfferInclusions = tileInclusions || []

    return [
      ...evergreenPackageInclusions,
      ...standardInclusions,
      ...flashOfferInclusions,
    ].map((inclusion, index) => {
      const isHighlighted = index === 0 || inclusion.isHighlighted

      const symbol = inclusion.symbol || (isHighlighted ? 'tag' : undefined)
      return {
        ...inclusion,
        symbol,
        isHighlighted,
      }
    }) as Array<App.PackageInclusion>
  }, [evergreenInclusions, standardInclusions, tileInclusions])

  const hasInclusions = !!allStandardInclusions.length || !!luxPlusInclusions?.length

  return <>
    {hasInclusions && <PromotionListWrapper>
      <Group direction="vertical" gap={gap} horizontalAlign="start">
        <CruiseLuxPlusInclusionList luxPlusInclusions={luxPlusInclusions} offer={offer} />

        {!!allStandardInclusions.length && <Group direction="vertical" gap={4} horizontalAlign="start">
          {!!allStandardInclusions.length && <BodyText weight="bold" variant="medium">
            <b>Highlights</b> (select packages only)
          </BodyText>}

          <Group direction="vertical" gap={4}>
            {allStandardInclusions.map((inclusion) => <OfferInclusionItem
              key={inclusion.id}
              inclusion={inclusion}
              colour={inclusion.isHighlighted ? 'highlight-secondary' : undefined}
              showMinStayDescription
            />)}
          </Group>
        </Group>}
      </Group>
    </PromotionListWrapper>}
  </>
}

export default CruiseInclusionList
